import styled, { css } from 'styled-components';
import colors from 'src/integration/styles/colors';

export const Table = styled.table`
  ${() => css`
      width: 100%;
      border-radius: 16px;
      
      thead tr:last-child td:last-child {
          border-top-right-radius: 16px;
      }
      
      thead tr:last-child td:first-child {
          border-top-left-radius: 16px;
      }
      
      tbody tr:last-child td:first-child {
          border-bottom-left-radius: 16px;
      }
      
      tbody tr:last-child td:last-child {
          border-bottom-right-radius: 16px;
      }
  `}
`;

export const Row = styled.tr``;

export const CellHeader = styled.td<{$left?: boolean, $bgGrey?: boolean}>`
  ${({ $left}) => css`
      padding: 12px 8px;
      font-size: 14px;
      line-height: 140%;
      font-weight: 700;
      text-align: ${$left ? 'left' : 'center'};
      color: ${colors.grey1};
  `}
`;

export const Cell = styled.td<{$left?: boolean, $bgGrey?: boolean, $bold?: boolean}>`
  ${({ $left, $bgGrey, $bold }) => css`
      padding: 8px;
      font-size: 16px;
      font-weight: ${$bold ? 700 : 400};
      line-height: 170%;
      color: ${colors.grey1};
      text-align: ${$left ? 'left' : 'center'};
      background: ${$bgGrey ? colors.grey5 : colors.primaryWhite};
      border-top: 1px solid ${colors.grey5};
  `}
`;